// src/data/exercises/L6_05.js

const accountOptions = [
  '売掛金', '買掛金', '商品', '売上', '売上原価'];

export const L6_05 = {
  title: '簿記　3級（第215-5回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

   parts: [
    { "type": "ruby", "text": "長野株式会社", "ruby": "ながのかぶしきがいしゃ" },
    { "type": "text", "value": "は、" },
    { "type": "ruby", "text": "静岡株式会社", "ruby": "しずおかかぶしきがいしゃ" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "商品", "ruby": "しょうひん" },
    { "type": "text", "value": "90" },
    { "type": "ruby", "text": "個", "ruby": "こ" },
    { "type": "text", "value": "（" },
    { "type": "ruby", "text": "原価", "ruby": "げんか" },
    { "type": "text", "value": "＠￥3,000、" },
    { "type": "ruby", "text": "売価", "ruby": "ばいか" },
    { "type": "text", "value": "＠￥8,000）を" },
    { "type": "ruby", "text": "販売", "ruby": "はんばい" },
    { "type": "text", "value": "し、" },
    { "type": "ruby", "text": "代金", "ruby": "だいきん" },
    { "type": "text", "value": "は" },
    { "type": "ruby", "text": "掛", "ruby": "か" },
    { "type": "text", "value": "けとした。なお、" },
    { "type": "ruby", "text": "長野株式会社", "ruby": "ながのかぶしきがいしゃ" },
    { "type": "text", "value": "では、" },
    { "type": "ruby", "text": "商品売買取引", "ruby": "しょうひんばいばいとりひき" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "関", "ruby": "かん" },
    { "type": "text", "value": "して、" },
    { "type": "ruby", "text": "販売", "ruby": "はんばい" },
    { "type": "text", "value": "のつど" },
    { "type": "ruby", "text": "売上原価勘定", "ruby": "うりあげげんかかんじょう" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "振", "ruby": "ふ" },
    { "type": "text", "value": "り" },
    { "type": "ruby", "text": "替", "ruby": "か" },
    { "type": "text", "value": "える" },
    { "type": "ruby", "text": "方法", "ruby": "ほうほう" },
    { "type": "text", "value": "（" },
    { "type": "ruby", "text": "売上原価対立法", "ruby": "うりあげげんかたいりつほう" },
    { "type": "text", "value": "）で" },
    { "type": "ruby", "text": "記帳", "ruby": "きちょう" },
    { "type": "text", "value": "している。" }
]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '売掛金', debitAmount: 720000, creditAccount: '売上', creditAmount: 720000 },
        { debitAccount: '売上原価', debitAmount: 270000, creditAccount: '商品', creditAmount: 270000 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'styled', value: '①「商品を販売し」→売上（90個×売価＠￥8,000）貸方（右・Ｃｒ）n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「代金は掛けとした」→売掛金の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '③販売のつど売上原価勘定に（売上原価対立法）\n' },
          { type: 'text', value: '＝売ったとき、\n' },
          { type: 'styled', value: '商品の減少（マイナス）貸方（右・Ｃｒ）', color: 'red', bold: true },
          { type: 'styled', value: '売上原価を借方（左・Ｄｒ）にする', color: 'red', bold: true },
          
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
①「商品を販売し」→売上（90個×売価＠￥8,000）が発生（プラス）

②「代金は掛けとした」→売掛金の増加（プラス）

③販売のつど売上原価勘定に（売上原価対立法）
＝売ったとき、商品が減少（マイナス）、売上原価の消滅（マイナス）

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {

        parts: [
          { type: 'styled', value: '①「商品を販売し」→売上（90個×売価＠￥8,000）貸方（右・Ｃｒ）n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「代金は掛けとした」→売掛金の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '③販売のつど売上原価勘定に（売上原価対立法）\n' },
          { type: 'text', value: '＝売ったとき、\n' },
          { type: 'styled', value: '商品の減少（マイナス）貸方（右・Ｃｒ）', color: 'red', bold: true },
          { type: 'styled', value: '売上原価を借方（左・Ｄｒ）にする', color: 'red', bold: true },
          
        ]

          }
        ],
       
      },
    },
  ],
};